import { Component, OnInit } from '@angular/core';
import { UserService } from './../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { department, interaction, division, user, usermaster } from './../../models/admin';
import { AdminApiService } from './../../services/admin.service';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
@Component({
  selector: 'app-dashboard',
  templateUrl: './admindashboard.component.html',
  styleUrls: ['./admindashboard.component.css']
})
export class AdminboardComponent implements OnInit {
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  public isAdmin: boolean = false;
  user: any = {};
  login_UserID: string; // number
  public user_data: any;
  public filterSettings: Object;
  constructor(private router: Router, private userService: UserService, public restApi: AdminApiService, private spinner: SpinnerVisibilityService) { }

  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.router.navigateByUrl('/access-denied/');
    }
    this.loadUserMaster();
    
    this.filterSettings = { type: 'Excel' };
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
  }

  // Get user list
  loadUserMaster() {
    this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 11;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = "1";
    
    this.restApi.getUserMasters(inpValue)
      .subscribe(data => {
        
        let rtnData: any = data;
        if (rtnData.data.length > 0) {
          this.user_data = rtnData.data;
        }
        //this.user_data = data;
        const mockDataset = [];
        for (let i = 0; i < this.user_data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            userUno: this.user_data[i].userUno,
            ntUsername: this.user_data[i].ntUsername,
            displayNameEn: this.user_data[i].displayNameEn,
            userPhoto: this.user_data[i].userPhoto,
            emailId: this.user_data[i].emailId,
            lastLogin: this.user_data[i].lastLogin
          };
        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'displayNameEn', name: 'Display Name', field: 'displayNameEn', sortable: true, formatter: this.nameFormatter,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'displayNameEn', 'displayNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'emailId', name: 'Email ID', field: 'emailId', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'emailId', 'emailId'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'lastLogin', name: 'Last Login', field: 'lastLogin', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'lastLogin', 'lastLogin'),
          model: Filters.multipleSelect,
        }
      }

    ]


  }

  nameFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return '<div class="e-image"><img class="e-avatar" src="' + dataContext.userPhoto + '" alt="user"></div><span class="name"> ' + dataContext.displayNameEn +'</span>';
  };

  

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }



}
